import { AnyAction } from '@reduxjs/toolkit';
import { combineEpics, StateObservable } from 'redux-observable';
import { distinctUntilChanged, filter, map, mergeMap, Observable, throttleTime } from 'rxjs';
import { mapPayload } from '../../../../../Utils/RxjsOperators/MapPayload';
import { StoreDependencies } from '../../StoreDependencies';
import { StoreState } from '../../StoreState';
import VideoAnalysisActions from '../VideoAnalysisActions';
import { readImageText } from './VideoAnalysisEpics';

function readMoonName(
  $action: Observable<AnyAction>,
  _$state: StateObservable<StoreState>,
  dependencies: Partial<StoreDependencies>
): Observable<AnyAction> {
  return $action.pipe(
    filter(VideoAnalysisActions.readMoonName.match),
    throttleTime(3000),
    mapPayload(),
    mergeMap(({ image, moonType, filterBrightness }) =>
      readImageText(
        image,
        dependencies.textProcessingManager!.processingData[moonType].nameFrame(filterBrightness),
        dependencies.imageCropper!,
        dependencies.imageFilterer!,
        dependencies.textReader!
      )
    ),
    distinctUntilChanged(),
    map(VideoAnalysisActions.setPredictedMoonName)
  );
}

export default combineEpics(readMoonName);
